// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
import { ErrorTrendBucket, IErrorTrendBucket } from "./CoreApi.Data.ErrorTrendBucket.gen";

export interface IErrorTrendResult {
	latestFirmware: string | undefined;

	buckets: IErrorTrendBucket[] | undefined;

	latestFirmwareDeviceCount: number;

	otherFirmwareDeviceCount: number;

	$type?: string | undefined;
}
export class ErrorTrendResult {
	constructor(data?: IErrorTrendResult) {
		if (!data) return;
		if (data.$type && data.$type !== this.$type) console.warn('The $type of data being parsed does not match the type of the object being created (' + this.$type + ')');
		Object.assign(this, data);
		this.buckets = data.buckets ? data.buckets.map((b: any) => new ErrorTrendBucket(b)) : [];
	}

	latestFirmware: string | undefined;

	buckets: ErrorTrendBucket[] | undefined = [];

	latestFirmwareDeviceCount: number = 0;

	otherFirmwareDeviceCount: number = 0;

	static $type: string = "CoreApi.Data.ErrorTrendResult, ";
	$type?: string | undefined = ErrorTrendResult.$type;
}

